
































































































import _ from 'lodash';
import { editFactory } from '@/main/pages';
import { NdSklad } from '@/modules/sklad/ndSklad';
import { openEdit } from '@/main/router/routerPath';
import { PageMode } from '@/main/utils/pageMode';
import { showAlert } from '@/main/utils/notifications';

import { NAME } from './constants';
import { editActions } from './store/types';
import { store } from './store/edit';

type NdSkladFilter = {
	VyrobekndOzn: string | null;
	NdNr: string | null;
	SkladOzn: number | null;
	NdText: string | null;
	EanCode: string | null;
};

export default editFactory(NAME, store).extend({
	components: {
		NdSkladSelectWithCheck: NdSklad.components.SelectWithCheck,
	},
	watch: {
		Mnozstvi(newValue) {
			if (this.NcCelkPrpCmp) {
				this.Nc = (this.NcCelkCmp ?? 0) / (newValue || 1);
			} else {
				this.NcCelk = (this.Nc ?? 0) * (newValue ?? 1);
				this.BalicJdn = (this.Pc ?? 0) * (newValue ?? 1);
				this.DiscAfterCalc = ((this.NcCelk ?? 0) * this.Discount!) / 100;
				this.PriceAfterDisc = this.NcCelk! - this.DiscAfterCalc!;
				this.PriceAfterDiscWithGst = this.PriceAfterDisc + (this.PriceAfterDisc * (this.Gst! / 100));
			}
		},
		Discount(newValue) {
			this.DiscAfterCalc = ((this.NcCelk ?? 0) * newValue!) / 100;
			this.PriceAfterDisc = this.NcCelk! - this.DiscAfterCalc!;
			if(this.dmsSys.EnableGSTPrp){
				this.PriceAfterDiscWithGst = this.PriceAfterDisc + (this.PriceAfterDisc * (this.Gst! / 100));
			}
			if(this.dmsSys.EnableVATPrp){
				this.PriceAfterDiscWithVat = this.PriceAfterDisc + (this.PriceAfterDisc * (this.Vat! / 100));
			}
		},
	},
	computed: {
		actionsMapper(): Record<string, string> {
			return {
				ndPolozky: `${this.storeUri}/${editActions.ND_SKLAD_POLOZKY_MAPPER}`,
			};
		},
		NcCelkKorCmp: {
			get(): number | null {
				return this.NcCelkKor;
			},
			set(newValue: number) {
				this.NcKor = newValue;
				this.NcCelkKor = newValue;
			},
		},
		ndskladFilter(): NdSkladFilter {
			return {
				VyrobekndOzn: this.VyrobekndOzn,
				NdNr: this.NdNr,
				SkladOzn: this.SkladOzn,
				NdText: this.Text,
				EanCode: this.eanKlic,
			};
		},
		isUzavreno(): boolean {
			return !!this.UzavreniDat;
		},
		NcCmp: {
			get(): number | null {
				return this.Nc;
			},
			set(newValue: number) {
				this.Nc = newValue;
				if (!this.NcCelkPrpCmp) {
					if (this.loggedUser.DmsSys.PROrdersPrp) {
						this.NcCelk = (newValue ?? 0) * (this.Mnozstvi || 1);
					} else {
						this.NcCelk = (newValue ?? 0) / (this.Mnozstvi || 1);
					}
				}
			},
		},
		NcCelkCmp: {
			get(): number | null {
				return this.NcCelk;
			},
			set(newValue: number) {
				this.Nc = (newValue ?? 0) / (this.Mnozstvi || 1);
				this.DiscAfterCalc = ((this.NcCelk ?? 0) * this.Discount!) / 100;
				this.PriceAfterDisc = this.NcCelk! - this.DiscAfterCalc!;
				this.PriceAfterDiscWithGst = this.PriceAfterDisc + (this.PriceAfterDisc * (this.Gst! / 100));
			},
		},
		NcCelkPrpCmp(): boolean {
			if (!this.loggedUser.DmsSys.PROrdersPrp) {
				return _.isNil(this.props.ncCelkPrpActual) ? !!this.NcCelkPrp : !!this.props.ncCelkPrpActual;
			}
			return false;
		},
		ndNrInputDisable(): boolean {
			return !!(this.isViewMode || this.ndNrDisable);
		},
		textInputDisable(): boolean {
			return this.isViewMode || this.textDisabled || this.isUzavreno;
		},

	},
	methods: {
		loadedData() {
			if (this.NdNr === null || this.NdNr === '') {
				this.NdNr = this.props.MioNdNr;
				this.VyrobekndOzn = this.props.VyrobekndOzn;
			}
			this.isCreateMode && (this.SkladOzn = this.props.SkladOzn!);
		},
		DiscountCalculation() {
			this.DiscAfterCalc = ((this.NcCelk ?? 0) * this.Discount!) / 100;
			this.PriceAfterDisc = this.NcCelk! - this.DiscAfterCalc!;
			this.PriceAfterDiscWithGst = this.PriceAfterDisc + (this.PriceAfterDisc * (this.Gst! / 100));
		},
		async customValidation() {
			if (this.props.TotalMnozstvi !== null && this.Mnozstvi !== null && this.props.Quantity !== null) {
				const QuantityAdded = this.props.TotalMnozstvi + this.Mnozstvi;
				if (this.props.Quantity < QuantityAdded) {
					showAlert({
						title: this.LocalizeChyboveHlasky('errorTitle'),
						message: this.LocalizeChyboveHlasky('POTotalQty'),
					});
					return false;
				}
			}
			if (this.Mnozstvi! === 0) {
				this.showErrorNotification(this.LocalizeChyboveHlasky('NDPrijemErrMnozstvi'));
				return false;
			}
			if (this.Discount! < 0 || this.Discount! > 100) {
				this.showErrorNotification(this.LocalizeChyboveHlasky('msgNotMoreDiscThn100Per'));
				return false;
			}
			if (this.skladKartaPnc && this.Pc! < this.skladKartaPnc) {
				if (!await this.showConfirmPokracovat('NDPrijemPCNC')) {
					return false;
				}
			}
			const nc = this.isUzavreno ? this.KorNc : this.Nc;
			if (this.PcNdsklad && this.Pc! <= nc!) {
				if (!await this.showConfirmPokracovat('NDPrijemPCNC2')) {
					return false;
				}
			}
			if (this.loggedUser.DmsSys.PROrdersPrp) {
				if (this.LeftToDeliverCount !== null && this.Mnozstvi !== null && this.Mnozstvi > this.LeftToDeliverCount) {
					this.showErrorNotification(this.LocalizeChyboveHlasky('ErrLeftDeliverCount'));
					return false;
				}
				if (this.NcCmp !== null && this.Pc !== null && this.NcCmp <= 0 && this.Pc <= 0) {
					if (!await this.showConfirmPokracovat(this.LocalizeChyboveHlasky('ErrEnterCPSP'))) {
						return false;
					}
				}
				return true;
			}
			return true;
		},
		async existSkladovaKarta() {
			this.startLoading();
			const { data: skladExists } = await NdSklad.apiProvider.getNdSklad({
				vyrobekndOzn: this.VyrobekndOzn!,
				ndNr: this.NdNr!,
				skladOzn: this.SkladOzn!,
			});
			this.endLoading();
			if (!skladExists) {
				const confirm = await this.showConfirm({ message: this.LocalizeChyboveHlasky('DoAddND') });
				if (confirm) {
					await openEdit(NdSklad.name, PageMode.CREATE, {
						filter: {
							SkladOzn: this.SkladOzn,
							VyrobekndOzn: this.VyrobekndOzn,
							NdNr: this.NdNr,
							Text: this.Text,
							EanCode: this.EanCode,
						},
					});
				}
				return false;
			}
			return true;
		},
		refreshFun() {
			this.$nextTick(() => {
				(this.$refs.ndSkladSelect as (Vue & { onCheckClick(): void })).onCheckClick();
			});
		},
	},
});
